const TITLE = {
  BJCC: 'BJCC',
  CAJUN: 'Cajundome',
  EDLEN: 'Edlen',
  TEST: 'Edlen',
};

export default TITLE;
